<div class="col-md-3" style="margin-bottom: 60px;">
  <nav class="side-navigation">
    <ul class="list-unstyled">
      <li class="title">
        <!--BEGIN Side NAV-->
        <ul>
          <li *ngIf = "selectedMainNav != 'nutritionServices' || !navExpanded">
            <span class="sr-only">Current:</span>
          <a id="nutritionServicesMainLnkExpand" (click)="selectMainNavMenu('nutritionServices')" tabindex="0" (keydown.enter)="selectMainNavMenu('nutritionServices')">
            <p>
              <strong>Nutrition Services</strong>
            </p>
          </a>
        </li>
          <li class="leadNav subActive" *ngIf = "selectedMainNav == 'nutritionServices' && navExpanded">
                <strong style="display: inline-block;" (click)="collapseNav()" tabindex="0" (keydown.enter)="collapseNav()">Nutrition Services</strong>
                <i class="fa fa-chevron-circle-down fa-2x" aria-hidden="true" (click)="collapseNav()" style="padding-left: 70px;"></i>
            <ul>
              <li *ngFor="let subNav of nutritionServicesNav" (click)="selectSubNavMenu(subNav)" tabindex="0" (keydown.enter)="selectSubNavMenu(subNav)">
                <a id="{{subNav.selectedSubMenu}}" [ngClass]="{ 'active': subNav.menu == selectedSubNav.menu }">
                  <p>{{subNav.menu}}</p>
                  <span *ngIf="subNav.menu == selectedSubNav.menu" >
                      <span class="sr-only">Current:</span>
                    <i class="fa fa-chevron-circle-right fa-2x" aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf = "selectedMainNav != 'respiteCare' || !navExpanded">
            <span class="sr-only">Current:</span>
          <a id="respiteCareLnkExpand" (click)="selectMainNavMenu('respiteCare')" tabindex="0" (keydown.enter)="selectMainNavMenu('respiteCare')">
            <p>
              <strong>Respite Care for Caregivers</strong>
            </p>
          </a>
        </li>
          <li class="leadNav subActive"  *ngIf = "selectedMainNav == 'respiteCare' && navExpanded">
            <strong style="display: inline-block;" (click)="collapseNav()" tabindex="0" (keydown.enter)="collapseNav()">Respite Care for Caregivers</strong>
            <i class="fa fa-chevron-circle-down fa-2x" aria-hidden="true" (click)="collapseNav()" style="padding-left: 10px;"></i>
            <ul>
              <li *ngFor="let subNav of RespiteCareNav" (click)="selectSubNavMenu(subNav)" tabindex="0" (keydown.enter)="selectSubNavMenu(subNav)">
                <a id="{{subNav.selectedSubMenu}}" [ngClass]="{ 'active': subNav.menu == selectedSubNav.menu }">
                  <p>{{subNav.menu}}</p>
                  <span *ngIf="subNav.menu == selectedSubNav.menu" >
                      <span class="sr-only">Current:</span>
                    <i class="fa fa-chevron-circle-right fa-2x" aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li  *ngIf = "selectedMainNav != 'servicesForCaregivers' || !navExpanded">
            <span class="sr-only">Current:</span>
          <a id="servicesForCaregiversLnkExpand" (click)="selectMainNavMenu('servicesForCaregivers')" tabindex="0" (keydown.enter)="selectMainNavMenu('servicesForCaregivers')">
            <p>
              <strong>Services for Caregivers</strong>
            </p>
          </a>
        </li>
          <li class="leadNav subActive" *ngIf = "selectedMainNav == 'servicesForCaregivers' && navExpanded">
            <strong style="display: inline-block;" (click)="collapseNav()" tabindex="0" (keydown.enter)="collapseNav()">Services for Caregivers</strong>
            <i class="fa fa-chevron-circle-down fa-2x" aria-hidden="true" (click)="collapseNav()" style="padding-left: 40px;"></i>
            <ul>
              <li *ngFor="let subNav of servicesForCaregiversNav" (click)="selectSubNavMenu(subNav)" tabindex="0" (keydown.enter)="selectSubNavMenu(subNav)">
                <a id="{{subNav.selectedSubMenu}}" [ngClass]="{ 'active': subNav.menu == selectedSubNav.menu }">
                  <p>{{subNav.menu}}</p>
                  <span *ngIf="subNav.menu == selectedSubNav.menu" >
                      <span class="sr-only">Current:</span>
                    <i class="fa fa-chevron-circle-right fa-2x" aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf = "selectedMainNav != 'supportiveServices' || !navExpanded">
            <span class="sr-only">Current:</span>
          <a id="supportiveServicesnkExpand" (click)="selectMainNavMenu('supportiveServices')" tabindex="0" (keydown.enter)="selectMainNavMenu('supportiveServices')">
            <p>
              <strong>Supportive Services</strong>
            </p>
          </a>
        </li>
          <li class="leadNav subActive" *ngIf = "selectedMainNav == 'supportiveServices' && navExpanded">
            <strong style="display: inline-block;" (click)="collapseNav()" tabindex="0" (keydown.enter)="collapseNav()">Supportive Services</strong>
            <i class="fa fa-chevron-circle-down fa-2x" aria-hidden="true" (click)="collapseNav()" style="padding-left: 60px;"></i>
            <ul>
              <li *ngFor="let subNav of supportiveServicesNav" (click)="selectSubNavMenu(subNav)" tabindex="0" (keydown.enter)="selectSubNavMenu(subNav)">
                <a id="{{subNav.selectedSubMenu}}" [ngClass]="{ 'active': subNav.menu == selectedSubNav.menu }">
                  <p>{{subNav.menu}}</p>
                  <span *ngIf="subNav.menu == selectedSubNav.menu" >
                      <span class="sr-only">Current:</span>
                    <i class="fa fa-chevron-circle-right fa-2x" aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            </ul>
          </li>
          </ul>
          <!--END Side NAV-->
        </li>
      </ul>
    </nav>
    <!-- .end navigation -->
  </div>
  <!-- .end panel -->